import Vue from "vue";
import Vuex from "vuex";

import { ObjectId } from "bson";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    files: {}
  },
  mutations: {
    setFiles(state, payload) {
      state.files = payload;
    }
  },
  actions: {
    async addFile(ctx, file) {
      const id = new ObjectId().toHexString();
      ctx.commit("setFiles", { ...ctx.state.files, [id]: file });
      return id;
    }
  }
});
